// GAME SETTINGS 
var millisecondsPerItem = 750
maxNumberOfRounds = 30
scoreDiv = document.getElementById('scoreDiv')
gameDiv = document.getElementById('game')
startButton = document.getElementById('start')
symbolsTable = document.getElementById('symbolsTable')
feedbackBox = document.getElementById('feedbackBox')
keyboardDiv = document.getElementById('keyboard')
instructions = document.getElementById('instructions')
settingsDiv = document.getElementById('settings')

slider = document.getElementById('tempo')
sliderLabel = document.getElementById('tempoLabel')

roundsSlider = document.getElementById('roundsSlider')
roundsLabel = document.getElementById('roundsLabel')


var urlParams = new URLSearchParams(window.location.search);
var inCourse = urlParams.get('in_course');

if (inCourse == null) {
    inCourse = 'false'
} else {
    settingsDiv.style.display = 'block'
}

function readSlider() {
    seconds = slider.value
    sliderLabel.innerHTML = seconds + ' Sekunden pro Symbol'
    millisecondsPerItem = seconds * 1000
}

readSlider()

function readRoundsSlider() {
    console.log('reading rounds slider')
    roundsValue = roundsSlider.value
    roundsLabel.innerHTML = roundsValue + ' Runden'
    maxNumberOfRounds = roundsValue
    console.log('max number of rounds: ' + roundsValue)
}

readRoundsSlider()



var score = 0
function createRandomLists() {
    let shuffledSymbols = symbolObjects.sort(() => Math.random() - 0.5);
    console.log(shuffledSymbols)
}


function getRandomSymbol() {
    var symbol = symbolObjects[Math.floor(Math.random() * symbolObjects.length)];
    console.log(symbol)
    return symbol
}





function evaluateKeypress(randomSymbol, pressedKey) {
    addSymbolToTable(randomSymbol, pressedKey)
}





function newRound() {
    if (round < maxNumberOfRounds) {
        randomSymbol = getRandomSymbol()
        var symbolDiv = document.getElementById('symbol')
        symbolDiv.innerHTML = `<img src='${randomSymbol.img}' />`
        addEventListener()    
    } else {
        stopGame()
    }

    
    
}






var randomSymbol = ''

function addEventListener() {
    var pressedKey = null;
    console.log('adding event listener')

    var keyPressListener = (event) => {
        pressedKey = event.key;
        console.log('pressed key: ' + pressedKey);
        addSymbolToTable(randomSymbol, pressedKey);
        document.removeEventListener('keypress', keyPressListener);
    };

    document.addEventListener('keypress', keyPressListener);

    setTimeout(() => {
        if (pressedKey == null) {
        addSymbolToTable(randomSymbol, pressedKey);
        }
        document.removeEventListener('keypress', keyPressListener);
    }, millisecondsPerItem - 10);
}


function startGame() {
    const body = document.getElementsByTagName('body')[0];
    body.style.textAlign = 'center';
    keyboardDiv.style.display = 'flex'
    gameDiv.style.display = 'flex'
    startButton.style.display = 'none'
    scoreDiv.style.display = 'block'
    instructions.style.display = 'none'
    
    document.getElementById('symbolsTable').style.display = 'block'
    
    timeLeft = 45
    startTimer(0)
    score = 0
    faults = 0
    round = 0



    
    runningGame = setInterval(() => {
        newRound()
    }, millisecondsPerItem);
  

}

